import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import React, { Dispatch, SetStateAction, useEffect } from 'react'

import { camelCaseToText } from '../../../../../utils/utils'
import { Preset } from '../../../Templates/utils'

const PresetValues: React.FC<{
  values: Preset
  setProperties: Dispatch<SetStateAction<{ [key: string]: any }>>
}> = ({ values, setProperties }) => {
  const theme = useMantineTheme()

  useEffect(() => {
    if (values) {
      Object.entries(values).map(([key, value]) =>
        setProperties(prev => ({
          ...prev,
          [key]: value,
        }))
      )
    }
  }, [values, setProperties])

  return (
    <Stack style={{ gap: '10px' }}>
      {Object.entries(values).map(([key, value]) => (
        <Stack key={key} style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
          <Title order={5} style={{ textAlign: 'left', option: theme.colors.paragraph[0] }}>
            {camelCaseToText(key)}:
          </Title>
          <Text style={{ color: theme.colors.textAndIcon[0] }}>{value}</Text>
        </Stack>
      ))}
    </Stack>
  )
}

export default PresetValues
